import { query } from 'data';
import { getInvoiceQuery } from 'hooks/queries';
import { Uuid } from 'types/common';

const invoiceLoader = (id?: Uuid) => query.ensureQueryData(getInvoiceQuery(id));

export {
  invoiceLoader,
};
